// Copyright (c) 2017 Deere & Company

import ProductHierarchyLevel from './product-hierarchy-level';
import t from 'tcomb';

const ProductHierarchy = t.struct({
    productHierarchy: t.list(ProductHierarchyLevel)
}, {
    name: 'ProductHierarchy',
    strict: true
});

export const getDefaultState = () => new ProductHierarchy({
    productHierarchy: []
});

export default ProductHierarchy;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/product-hierarchy.js